// extracted by mini-css-extract-plugin
export default {"mealBlock":"DishPriorities_mealBlock__JWSWT","mealName":"DishPriorities_mealName__0FHa-","dish":"DishPriorities_dish__nDtDh"};